import { NAMESPACE } from "./_Namespace";

export interface IPromisePublic<T = void> extends Promise<T>
{
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason?: any) => void;
}

export class PromiseHelper
{
    public static classNamespace = NAMESPACE + "PromiseHelper";
    public static className = "PromiseHelper";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    public static createPromisePublic<T = void>()
    {
        let
            resolve: (value: T | PromiseLike<T>) => void,
            reject: (reason?: any) => void;

        const
            promise = new Promise<T>((_resolve, _reject) =>
            {
                resolve = _resolve;
                reject = _reject;
            }) as IPromisePublic<T>;

        promise.resolve = resolve!;
        promise.reject = reject!;

        return promise;
    }
}